import Popup from 'reactjs-popup';
import 'reactjs-popup/dist/index.css';
import React, { useState } from 'react'
import { useAuthState } from '../../../../../Helper/Context';
import { useDispatch } from 'react-redux';
import { WorkNameMasterPostDataAPI } from '../../../../../Redux/RoadDashboardSlice/WorkNameSlice';
import { HeadingDDL } from '../../../../../Components/CommonDDL/HeadingDDL';

export default function RoadMasterWorkNamePopup(props) {

    const { handleOnCloseClick, open, Flag, handleIsPost, rowData, } = props

    const userDetails = useAuthState();
    const { UserID, token, } = userDetails.user
    const dispatch = useDispatch()

    const [WorkNameTextField, setWorkNameTextField] = useState({
        workName: Flag === 'Update' ? rowData.workName : '',
        benchMark: Flag === 'Update' ? rowData.benchMark : '',
        penalty_Description: Flag === 'Update' ? rowData.penalty_Description : '',
        penalty_Values: Flag === 'Update' ? rowData.penalty_Values : '',
    });

    const handleInputChange = (e) => {
        setWorkNameTextField({ ...WorkNameTextField, [e.target.name]: e.target.value })
    }

    const [WorkType, setWorkType] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",
    })
    const [HeadingDDLID, setHeadingDDLID] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",
    })

    const handlePost = () => {
        const data = {

            M_RM_WorkID: Flag === 'Update' ? rowData.m_rM_WorkID : '0',
            WorkName: WorkNameTextField?.workName,
            IsOtherWork: '',
            PenaltyPeriodHours: '',
            BenchMark: WorkNameTextField?.benchMark,
            Penalty_Description: WorkNameTextField?.penalty_Description,
            Penalty_Values: WorkNameTextField?.penalty_Values,
            Heading: HeadingDDLID.Label,
            DisplayOrder: '0',
            M_UserID: UserID,
            token: token,
            Flag: Flag === 'Update' ? 'Update' : 'Insert',
            handleIsPost: handleIsPost,
            // handleClear:handleClear
            handleOnCloseClick: handleOnCloseClick

        }
        dispatch(WorkNameMasterPostDataAPI({ data }))
    }



    return (
        <Popup
            open={open} closeOnDocumentClick={false} onClose={handleOnCloseClick}
        >
            <div className="location_mob_pop modal-dialog modal-dialog-scrollable modal-xl" style={{ alignItems: "center", justifyContent: 'center' }}>
                <div className="modal-content road_ward_modal" style={{ marginLeft: "-1em" }}>
                    <div className="modal-header pl-4 p-1">
                        <h4 className="modal-title" id="staticBackdropLabel">Work Name</h4>
                        <button onClick={handleOnCloseClick} className="btn-close m-1 mr-3" type="button" />
                    </div>
                    <div className="modal-body">
                        <div className='inner-modal-body'>
                            <div className="row details-row">
                                <div className="col-12 col-lg-6">
                                    <HeadingDDL
                                        HeadingDDLID={HeadingDDLID}
                                        setHeadingDDLID={setHeadingDDLID}
                                    />
                                </div>
                                <div className=" col-12 col-lg-6">
                                    <div className="form-group">
                                        <label className="d-block" htmlFor="NameofDepartment"><b>Work Name</b></label>
                                        <input type="text"
                                            className="form-control"
                                            id="workName"
                                            aria-describedby="emailHelp"
                                            name='workName'
                                            value={WorkNameTextField.workName}
                                            onChange={(e) => handleInputChange(e)}
                                        />

                                    </div>
                                </div>
                                <div className="col-12 col-lg-6">
                                    <div className="form-group">
                                        <label className="d-block" htmlFor="NameofDepartment"><b>BenchMarkBenchMark (Days)</b></label>
                                        <input type="text"
                                            className="form-control"
                                            id="benchMark"
                                            aria-describedby="emailHelp"
                                            name='benchMark'
                                            value={WorkNameTextField.benchMark}
                                            onChange={(e) => handleInputChange(e)}
                                        />

                                    </div>
                                </div>
                                <div className="col-12 col-lg-6">
                                    <div className="form-group">
                                        <label className="d-block" htmlFor="NameofDepartment"><b>Penalty_Description</b></label>
                                        <input type="text"
                                            className="form-control"
                                            id="penalty_Description"
                                            aria-describedby="emailHelp"
                                            name='penalty_Description'
                                            value={WorkNameTextField.penalty_Description}
                                            onChange={(e) => handleInputChange(e)}
                                        />

                                    </div>
                                </div>
                                <div className="col-12 col-lg-6">
                                    <div className="form-group">
                                        <label className="d-block" htmlFor="NameofDepartment"><b>Penalty Amount (Rs.)</b></label>
                                        <input type="text"
                                            className="form-control"
                                            id="penalty_Values"
                                            aria-describedby="emailHelp"
                                            name='penalty_Values'
                                            value={WorkNameTextField.penalty_Values}
                                            onChange={(e) => handleInputChange(e)}
                                        />

                                    </div>
                                </div>
                            </div>

                            <div className="col-12 col-lg-12 pt-lg-5 pt-md-5 pt-3">
                                <div className="btn-action d-flex justify-content-end">
                                    <button type='button'
                                        className="btn allBtn  float-right submit_btn"
                                        onClick={() => handlePost()}
                                        disabled={
                                            HeadingDDLID.ID == 0 || WorkNameTextField.workName == '' ||
                                            WorkNameTextField.benchMark == '' || WorkNameTextField.penalty_Description == '' ||
                                            WorkNameTextField.penalty_Values == ''}
                                    >{Flag === "Update" ? "Update" : "Save"} </button>

                                    <button type="button" className="btn addBtns cancel_btn ms-2 mr-2 mx-2  float-right" onClick={handleOnCloseClick} >Cancel</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* )} */}
        </Popup>
    )

}